import React from 'react';
import { marqueeTrack } from '../../lib/motion';

// Bande qui défile en continu (animation CSS, voir .marquee dans index.css) : la liste est
// répétée pour dépasser la largeur du conteneur, puis doublée pour boucler sans trou.
// Pause au survol ou au focus ; en mouvement réduit, la bande devient une liste statique.
// Seule la première copie est lue par les lecteurs d'écran.
export default function Marquee({ items, renderItem, seconds = 40, className = '', ariaLabel }) {
  const track = marqueeTrack(items, 16);
  if (track.length === 0) return null;
  const group = (hidden) => (
    <ul className="marquee__group" aria-hidden={hidden ? 'true' : undefined}>
      {track.map((item, i) => (
        <li key={i}>{renderItem(item, i)}</li>
      ))}
    </ul>
  );
  return (
    <div className={`marquee ${className}`} aria-label={ariaLabel}>
      <div className="marquee__track" style={{ '--marquee-duration': `${seconds}s` }}>
        {group(false)}
        {group(true)}
      </div>
    </div>
  );
}
